module.exports = __webpack_public_path__ + "static/media/wells-chan-H-vAxuWxmi8-unsplash.2b6ac243.jpg";